/* Helpers for the Laos sales-geo dashboard: number formatting, the choropleth
   colour scale, and matching a GeoJSON province feature to our pr_id. */

// ── number formatting ──────────────────────────────────────────────────────
export function fmtKip(n) {
    n = Number(n) || 0;
    const abs = Math.abs(n);
    if (abs >= 1e9) return '₭' + (n / 1e9).toFixed(abs >= 1e10 ? 1 : 2) + 'B';
    if (abs >= 1e6) return '₭' + (n / 1e6).toFixed(abs >= 1e7 ? 0 : 1) + 'M';
    if (abs >= 1e3) return '₭' + Math.round(n / 1e3) + 'K';
    return '₭' + Math.round(n);
}

export function fmtFull(n) {
    return '₭' + (Number(n) || 0).toLocaleString('en-US');
}

// exact millions with a thousands separator, e.g. 19,139,748,000 → "₭19,140M"
export function fmtMillion(n) {
    n = Number(n) || 0;
    if (!n) return '₭0';
    return '₭' + Math.round(n / 1e6).toLocaleString('en-US') + 'M';
}

// ── choropleth colour ramp ─────────────────────────────────────────────────
function lerp(a, b, t) {
    return a + (b - a) * t;
}
function hexToRgb(h) {
    return [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)];
}
function mix(c1, c2, t) {
    const a = hexToRgb(c1);
    const b = hexToRgb(c2);
    return 'rgb(' + Math.round(lerp(a[0], b[0], t)) + ',' + Math.round(lerp(a[1], b[1], t)) + ',' + Math.round(lerp(a[2], b[2], t)) + ')';
}
export function makeScale(stops) {
    return function (t) {
        t = Math.max(0, Math.min(1, t));
        const seg = t * (stops.length - 1);
        const i = Math.min(stops.length - 2, Math.floor(seg));
        return mix(stops[i], stops[i + 1], seg - i);
    };
}

// ── GeoJSON feature → our pr_id ─────────────────────────────────────────────
export function norm(s) {
    return (s || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[^a-z]/g, ''); // NFD + a-z filter drops accents & combining marks
}

// geoBoundaries ADM1 shapeName (normalized) → our provinces.pr_id
const ALIAS = {
    xaignabouli: '8',
    attapeu: '17',
    bokeo: '5',
    bolikhamsai: '11',
    champasak: '16',
    houaphan: '7',
    khammouane: '12',
    luangnamtha: '3',
    luangprabang: '6',
    oudomxay: '4',
    phongsaly: '2',
    salavan: '14',
    savannakhet: '13',
    vientianecapital: '1',
    vientiane: '10',
    xaisomboun: '18',
    xekong: '15',
    xiangkhouang: '9'
};

export function matchProvinceId(props) {
    const raw = props && (props.shapeName || props.NAME_1 || props.name || props.ADM1_EN);
    if (raw) {
        const k = norm(raw);
        if (ALIAS[k]) return ALIAS[k];
    }
    return null;
}

// green ramp used across the section
export const ACCENT = '#1F8A5B';
export const SCALE_STOPS = ['#eaf3ee', '#cfe6da', '#9fd0b6', '#5cb88a', '#2f9e6a', '#1F8A5B', '#0f6b43'];
